import socketServerNexmo from "socket/socketServerNexmo";

const socketNexmoMaintenance = (getDataServerNexmo) => {
  socketServerNexmo.on('notification', (data) => {
    if(data){
      getDataServerNexmo({...data,errCode: data['err-code']})
    }else{
      getDataServerNexmo({})
    }
  });
};

export default socketNexmoMaintenance;
